import jQuery           from './vendors/jquery.min';
window.$ = window.jQuery = jQuery;

import browserCheck         from './modules/browser-check';
import bodyClasses          from './modules/body-classes';
import background           from './modules/background';
import inView               from './modules/viewport';
import mainMenu             from './modules/menu';
import vhFix                from './modules/vh-fix';
import scroller             from './modules/scroller';
import intScrollHandler     from './modules/internal-scroll-handler';
import accessibilityWidget  from './modules/accessibility-widget';
import heroSlider           from './modules/hero-slider';
import handleHighlights     from './modules/handle-highlights';
import counter              from './modules/counter';
import postsFilter          from './modules/posts-filter';
import faq                  from './modules/faq';
import testimonialsCarousel from './modules/testimonials-carousel';
import modals               from './modules/modals';
import syncPostsHandler     from './modules/sync-posts-handler';

class App {
    constructor () {
        browserCheck();
        bodyClasses();
        background();
        inView();
        mainMenu();
        vhFix();
        scroller();
        intScrollHandler();
        accessibilityWidget();
        heroSlider();
        handleHighlights();
        counter();
        postsFilter();
        faq();
        testimonialsCarousel();
        modals();
        syncPostsHandler();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new App(); // eslint-disable-line
});
